const LAZY_LOAD_VIEW = (path) => () =>
  import(
    /* webpackChunkName: "view-operations-compu-meeting-coordination-[request]" */ `@/views/pei/compu-meeting-coordination/${path}`
  );

export const COMPU_MEETING_COORDINATION_ROUTES = [
  {
    path: 'compu-meeting-coordination',
    component: LAZY_LOAD_VIEW`Wrapper.vue`,
    children: [
      {
        path: '',
        name: 'compu-meeting-coordination',
        component: LAZY_LOAD_VIEW`Main.vue`,
      },
    ],
  },
];
